/* eslint-disable jsx-a11y/anchor-is-valid */
import { Formik, FormikProps } from "formik";
import { groupBy } from "lodash";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useLocation, useSearchParams } from "react-router-dom";
import AGSelect from "../../components/AgSelect";
import AGButton from "../../components/Button";
import AGButtonV2 from "../../components/ButtonV2";
import Card from "../../components/Card";
import AGModalComfirmModal from "../../components/ComfirmModal";
import AGInput from "../../components/Input";
import { useNotification } from "../../components/Notification";
import { TblInboxMessage } from "../../models";
import { UserContext } from "../../Provider";
import { InboxMessageContext } from "../../Provider/InboxMessageContext";
import { httpDELETE, httpDownload, httpGET, httpPOST, httpPUT } from "../../utils/ajaxHelper";
import { API_CONSTANT, INQUIRY_MORE_OPTION } from "../../utils/constant";
import { compare } from "../../utils/sort";
import { CustomButtonSearch } from "../searchServices/searchItem.styled";
import AddInquiryModal from "./addInquiryModal";
import { IInquiryCreatingInfo } from "./addInquiryModal/addInquiry.props";
import EditInquiryModal from "./editInquiryModal";
import { IInquiryDetails } from "./editInquiryModal/editInquiry.props";
import {
  IInboxMessageProps,
  ISearchInboxData,
  ISearchInboxParam,
  ITabName,
  IUpdateReadedInboxMessage,
  CountryWithRegion
} from "./inboxMessage.props";
import { Container, MobileSearch, SearchBlock } from "./inboxMessage.styled";
import MailTable from "./mailTable";
import MessageDetailModal from "./messageDetailModal";
import MessageModal from "./MessageModal";
import SentMailTable from "./SentMailTable";
import { AddIconDatePicker } from "../../components/AddIconDatePicker";
import { StyledDatePicker, WrappedDatePicker, MobileWrappedDatePicker } from "./inboxMessage.styled"
import Tooltip from "../../components/Tooltip";
import { handleNumericDateInput } from "../../utils/helper";

export const InboxMessagePage: React.FC<IInboxMessageProps> = ({ ...props }: IInboxMessageProps) => {
  const user = useContext(UserContext);
  const roles = user?.roles ?? [];
  const location = useLocation();
  const inboxMessageContext = useContext(InboxMessageContext);
  const TAB_NAME: ITabName[] =
    roles.includes("ManagingPartner") || roles.includes("ServiceContact") || roles.includes("FirmCommerceManagement") || roles.includes("Admin")
      ? [
        {
          key: "tab_received_inbox",
          name: "Received",
        },
        {
          key: "tab_sent_inbox",
          name: "Sent",
        },
      ]
      : inboxMessageContext!.unreadInboxMessage! >= 1 || user?.individual.hasMessage
        ? [
          {
            key: "tab_received_inbox",
            name: "Received",
          },
          {
            key: "tab_sent_inbox",
            name: "Sent",
          },
        ]
        : [
          {
            key: "tab_sent_inbox",
            name: "Sent",
          },
        ];

  const [searchURLParams, setSearchURLParam] = useSearchParams();
  const TAB_DISPLAY = TAB_NAME;

  const [searchParam, setSearchParam] = useState<ISearchInboxParam>({
    tabName: TAB_NAME[0].key,
    page: 1,
    offerorTypeId: undefined,
    offeringTypeId: undefined,
    experiseServiceId: undefined,
    productCategoryId: undefined,
    InquiryTypeId: undefined,
    InquiryInitator: undefined,
    InquiryStatusId: undefined,
    specializedSecondmentId: undefined,
    isSearch: true,
    inboxMessageId: undefined,
    timeZone: new Date().getTimezoneOffset() / -60,
    startDate: undefined,
    endDate: undefined
  });

  const formRef = useRef<FormikProps<any>>(null);
  const [inboxMessageData, setInboxMessageData] = useState<ISearchInboxData>({});
  const [inboxMessageSearchData, setInboxMessageSearchData] = useState<TblInboxMessage[]>([]);
  const [inboxDetail, setInboxDetail] = useState<TblInboxMessage | undefined>(undefined);
  const [showConfirmDelete, setShowConfirmDelete] = useState<boolean>(false);
  const [, setActionName] = useState<string | undefined>(undefined);
  const [, setActionSeleted] = useState<TblInboxMessage | undefined>(undefined);
  const { showNotification } = useNotification();
  const [openMobileMenu, setOpenMobileMenu] = useState<boolean>(false);
  const [searchParamResetData, setSearchParamResetData] = useState<any>({});
  const [countriesWithRegions, setCountriesWithRegions] = useState<CountryWithRegion[]>([]);
  const resetClearForm = {
    ...searchParam,
    page: 1,
    offerorTypeId: undefined,
    offeringTypeId: undefined,
    experiseServiceId: undefined,
    productCategoryId: undefined,
    InquiryTypeId: undefined,
    InquiryInitator: undefined,
    InquiryStatusId: undefined,
    specializedSecondmentId: undefined,
    isSearch: true,
    startDate: undefined,
    endDate: undefined
  }


  const [showAddingInquiryForm, setShowAddingInquiryForm] = useState(false);
  const [showEditingInquiryForm, setShowEditingInquiryForm] = useState(false);
  const [deletedInboxMessageId, setDeletedInboxMessageId] = useState(0);
  const [inquiryCreatingInfo, setInquiryCreatingInfo] = useState<IInquiryCreatingInfo | null>(null);
  const [inquiryDetails, setInquiryDetails] = useState<IInquiryDetails | null>(null);
  const [isClickAddInquiry, setIsClickAddInquiry] = useState(false);
  const [isClickExportExcel, setIsClickExportExcel] = useState(false);
  const [isClickFilterOnMobile, setIsClickFilterOnMobile] = useState(false);
  const calendarStartDateWrapperRef = useRef<HTMLDivElement | null>(null);
  const mobileCalendarStartDateWrapperRef = useRef<HTMLDivElement | null>(null);
  const [isSelectingStartDate, setIsSelectingStartDate] = useState(true);
  const [isCalendarDateRangeOpen, setIsCalendarDateRangeOpen] = useState(false);
  const [dateRangeMinDate, setDateRageMinDate] = useState<Date | undefined>(undefined);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const isMobileScreen = screenWidth < 769;

  const [initDefaultValue, setInitDefaultValue] = useState<any>({
    orgTypes: [],
    comOfferorTypes: [],
    comOfferingTypes: [],
    specializedServices: [],
    specializedProducts: [],
    inquiryTypes: [],
    inquiryStatuses: [],
    specializedSecondments: [],
  });

  const [messageModel, setMessageModel] = useState({
    action: "ADD",
    title: "Add new inquiry",
    isShowModal: false,
    messageDetail: undefined,
    readonly: true,
  });

  const { mutate: searchInboxMessage, isLoading: isLoadingInbox } = useMutation(
    () =>
      httpGET({
        url: API_CONSTANT.INBOX_MESSAGE.INBOX_MESS_EP,
        params: {
          page: searchParam.page,
          filterBy: searchParam.filterBy?.value,
          tabName: searchParam.tabName,
          offerorTypeId: searchParam.offerorTypeId,
          offeringTypeId: searchParam.offeringTypeId,
          experiseServiceId: searchParam.experiseServiceId,
          productCategoryId: searchParam.productCategoryId,
          specializedSecondmentId: searchParam.specializedSecondmentId,
          InquiryTypeId: searchParam.InquiryTypeId,
          InquiryInitator: searchParam.InquiryInitator,
          InquiryStatusId: searchParam.InquiryStatusId,
          startDate: searchParam.startDate,
          endDate: searchParam.endDate
        },
      }),
    {
      onSuccess: (rs) => {
        if (rs) {
          setInboxMessageData(rs);
          setInboxMessageSearchData((searchParam.page === 1 ? rs.data : [...inboxMessageSearchData, ...rs.data]) ?? []);
        };
        setSearchParam({
          ...searchParam,
          isSearch: false,
        });
      },
    },
  );

  const { mutate: getInboxMessageById } = useMutation(
    (inboxMessageId: any) =>
      httpGET({
        url: API_CONSTANT.INBOX_MESSAGE.GET_BY_ID,
        params: {
          id: inboxMessageId
        },
      }),
    {
      onSuccess: (rs) => {
        setInboxDetail(rs);
        setMessageModel({
          ...messageModel,
          action: "DETAIL",
          title: "Inquiry Details",
          isShowModal: true,
          readonly: true,
        });
      },
      onError: (rs: any) => {
        setInboxDetail(undefined);
        if (rs.statusCode === 404){
          window.location.href = "/404";
        }else{
          showNotification(rs.message, "Error");
        }
      }
    },
  );

  const { mutate: handleDownload } = useMutation(
    () =>
      httpDownload({
        url: API_CONSTANT.INBOX_MESSAGE.INBOX_EXPORTEXCEL,
        params: {
          page: searchParam.page,
          filterBy: searchParam.filterBy?.value,
          tabName: searchParam.tabName,
          offerorTypeId: searchParam.offerorTypeId,
          offeringTypeId: searchParam.offeringTypeId,
          experiseServiceId: searchParam.experiseServiceId,
          productCategoryId: searchParam.productCategoryId,
          InquiryTypeId: searchParam.InquiryTypeId,
          InquiryInitator: searchParam.InquiryInitator,
          InquiryStatusId: searchParam.InquiryStatusId,
          timeZone: searchParam.timeZone,
          startDate: searchParam.startDate,
          endDate: searchParam.endDate
        },
      }),
    {
      onSuccess: (rs) => {
      },
      onError: (rs: any) => {
        showNotification(rs.message, "Error");
      },
    },
  );

  const { mutate: getCountUnreadInbox } = useMutation(
    () =>
      httpGET({
        url: API_CONSTANT.INBOX_MESSAGE.COUNT_UNREAD,
      }),
    {
      onSuccess: (rs) => {
        inboxMessageContext?.setUnreadInboxMessage(rs ?? 0);
      },
    },
  );

  const { mutate: updateReadedInbox } = useMutation(
    (data: IUpdateReadedInboxMessage) =>
      httpPOST({
        url: API_CONSTANT.INBOX_MESSAGE.INBOX_READED,
        data,
      }),
    {
      onSuccess: (rs) => {
        if (rs && rs.updateStatus) {
          setInboxMessageSearchData(prevData =>
            prevData.map(item =>
                item.inboxMessageId === rs.inboxMessageId ? {...item, isReaded: true} : item
            )
          );
          setInboxMessageData((prevData) => ({
            ...prevData,
            data: prevData.data?.map((item) =>
              item.inboxMessageId === rs.inboxMessageId ? {...item, isReaded: true} : item,
            ),
          }));
        }
      },
    },
  );

  const { mutate: getMetaDataInquiry } = useMutation(
    () =>
      httpPOST({
        url: API_CONSTANT.INBOX_MESSAGE.INBOX_METEDATA,
      }),
    {
      onSuccess: (rs) => {
        const groupOfferingType = groupBy(
          rs?.comOfferingMainServices,
          (item) => `${item.fkOfferingTypeId}`,
        );
        Object.entries(groupOfferingType).forEach(([key, items]) => {
          if (key === "1") {
            rs.specializedServices = [...items];
          } else if (key === "2") {
            rs.specializedProducts = [...items];
          } else if (key === "3") {
            rs.specializedSecondments = [...items];
          } else console.log("Non key ", key);
        });

        setInitDefaultValue(rs);
      },
    },
  );

  const { mutate: getInquiryCreatingInfo, isLoading: isLoadingInquiryCreatingInfo } = useMutation(
    () =>
      httpGET({
        url: "/Inquiry/inquiry-creating-info",
      }),
    {
      onSuccess: (rs) => {
        setInquiryCreatingInfo(rs);
      },

      onError: (e) => {
      },
    },
  );

  const { mutate: editInquiry } = useMutation(
    (data: any) =>
      httpPUT({
        url: "/Inquiry/update",
        data: data,
      }),
    {
      onSuccess: (rs: TblInboxMessage) => {
        setShowEditingInquiryForm(false);
        setInboxMessageSearchData(prevData =>
          prevData.map(item =>
            item.inboxMessageId === rs.inboxMessageId ? rs : item
          )
        );
        setInboxMessageData((prevData) => ({
          ...prevData,
          data: prevData.data?.map((item) =>
            item.inboxMessageId === rs.inboxMessageId ? rs : item,
          ),
        }));
      },
      onError: (rs: any) => {
        setShowEditingInquiryForm(true);
        showNotification("Error happened", "Error");
      },
    },
  );

  const { mutate: getInquiryDetails, isLoading: isLoadingInquiryDetails } = useMutation(
    (inboxMessageId: any) =>
      httpGET({
        url: `/Inquiry/inquiry-details?inboxMessageId=${inboxMessageId}`,
      }),
    {
      onSuccess: (rs) => {
        setInquiryDetails(rs);
      },
      onError: (e) => {
        setShowEditingInquiryForm(false);
        showNotification("Error happened", "Error");
      },
    },
  );


  const updateInfoAction = (action: string, data?: any) => {
    setActionName(action);
    if (action === "Delete") {
      setShowConfirmDelete(true);
      setActionSeleted(data);
    } else if (action === "Edit") {
      setActionSeleted(data);
    }
  };

  const handleExportToExcel = () => {
    if (!inboxMessageSearchData.length) {
      showNotification("There is no data shown to export.", "Error");
      return;
    }
    handleDownload();
  }

  const { mutate: deleteInquiry } = useMutation(
    (inboxMessageId: any) =>
      httpDELETE({
        url: `/Inquiry/delete`,
        params: {
          inboxMessageId: inboxMessageId,
          page: searchParam.page,
          filterBy: searchParam.filterBy?.value,
          tabName: searchParam.tabName,
          offerorTypeId: searchParam.offerorTypeId,
          offeringTypeId: searchParam.offeringTypeId,
          experiseServiceId: searchParam.experiseServiceId,
          productCategoryId: searchParam.productCategoryId,
          specializedSecondmentId: searchParam.specializedSecondmentId,
          InquiryTypeId: searchParam.InquiryTypeId,
          InquiryInitator: searchParam.InquiryInitator,
          InquiryStatusId: searchParam.InquiryStatusId,
          startDate: searchParam.startDate,
          endDate: searchParam.endDate
        },
      }),
    {
      onSuccess: (rs: any) => {
        setInboxMessageSearchData(inboxMessageSearchData.filter(x=>x.inboxMessageId !== rs.deletedInboxMessageId));
        setInboxMessageData(prev => ({
          ...prev,
          maxLength: prev.maxLength! - 1,
          data: prev.data?.filter(x => x.inboxMessageId !== rs.deletedInboxMessageId)
        }));

        if (rs.appendedInboxMessage !== null){
          setInboxMessageSearchData(prev => [...prev, rs.appendedInboxMessage]);
          setInboxMessageData(prev => ({
            ...prev,
            data: [...(prev?.data ?? []), rs.appendedInboxMessage]
          }));
        }

        setShowConfirmDelete(false);
        updateReadedInbox({
          inboxMessageId: rs.inboxMessageId
        });
        getCountUnreadInbox();
      },
      onError: (e) => {
        showNotification("Error happened", "Error");
      },
    },
  );

  const { mutate: getAllCountriesWithRegions } = useMutation(
    () =>
      httpGET({
        url: "/agnetregion/get-all-countries-regions",
      }),
    {
      onSuccess: (rs: CountryWithRegion[]) => {
        setCountriesWithRegions(rs);
      },
    },
  );

  useEffect(() => {
    const searchURLParams = new URLSearchParams(location.search);
    const inboxMessageId = searchURLParams.get("inboxMessageId");
    if (inboxMessageId !== null) {
      getInboxMessageById(inboxMessageId);
      removeQueryParam("inboxMessageId")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (searchParam.page && searchParam.tabName && searchParam.isSearch) {
      searchInboxMessage();
      getCountUnreadInbox();
    }

  }, [searchInboxMessage, searchParam, getCountUnreadInbox]);

  useEffect(() => {
    getMetaDataInquiry();
    getInquiryCreatingInfo();
    getAllCountriesWithRegions();
    // eslint-disable-next-line react-hooks/exhaustive-deps

    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeQueryParam = (param: string) => {
    searchURLParams.delete(param);
  };

  const onKeepAliveField = () => {
    if (!Object.keys(searchParamResetData).length) {
      formRef.current?.resetForm()
      setSearchParam(resetClearForm);
    }
    else {
      let resetSearchParam = {};
      Object.entries(searchParamResetData).forEach(([key, value]) => {
        formRef.current?.setFieldValue(key, value ?? null);

        resetSearchParam = {
          ...resetSearchParam,
          [key]: typeof value === "object" ? (value as any)?.value : value ?? null,
        }
      });

      Object.keys(resetSearchParam).length && setSearchParam({
        ...searchParam,
        ...resetSearchParam,
        isSearch: false
      })
    }
  }

  return (
    <div
    // className="bg-[#E4E4E4] min-h-[100dvh]"
    >
      {inquiryCreatingInfo !== null && (
        <>
          <AddInquiryModal
            visible={showAddingInquiryForm && !isLoadingInquiryCreatingInfo}
            inquiryCreatingInfo={inquiryCreatingInfo}
            countriesWithRegions={countriesWithRegions}
            toggleModal={() => {
              setShowAddingInquiryForm(false);
            }}
            onPreCreateInquiry = {()=>{
              setSearchParam({...searchParam, page: 1})
            }}
            onCreateInquirySuccessfully={() => {
              getCountUnreadInbox();
              setInboxMessageSearchData([]);
              setInboxMessageData({});
              searchInboxMessage();
            }}
          />
        </>
      )}
      {inquiryDetails !== null && inquiryCreatingInfo !== null && (
        <EditInquiryModal
          visible={showEditingInquiryForm}
          toggleModal={() => {
            setShowEditingInquiryForm(false);
          }}
          editInquiry={editInquiry}
          inquiryDetails={inquiryDetails}
          isLoadingInquiryDetails={isLoadingInquiryDetails}
          inquiryCreatingInfo={inquiryCreatingInfo!}
        />
      )}
      <MessageDetailModal
        toggleModal={() => {
          setInboxDetail(undefined);
        }}
        visible={false}
        inboxDetail={inboxDetail}
      />

      <Container isMobileScreen={isMobileScreen}>
        <div
          className={`flex flex-col mt-[-125px] 769:mt-[0px] 769:flex-row ${
            !isMobileScreen ? " space-x-5 " : ""
            }`}
        >
          <div className={`${isMobileScreen ? "" : "mt-[20px]"} w-full 769:w-[260px]`}>
            {isMobileScreen ? (
              <>
                <Formik
                  innerRef={formRef}
                  initialValues={searchParam}
                  onSubmit={(values) => {}}
                >
                  {({values, setFieldValue, submitForm, setValues, resetForm}) => {
                    return (
                      <MobileSearch
                        style={{
                          left: openMobileMenu ? "0" : "-100%",
                        }}
                      >
                        <div
                          onClick={() => {
                            setOpenMobileMenu(false);
                            onKeepAliveField();
                          }}
                          className="close-button"
                        >
                          <CloseButton />
                        </div>
                        <form className="mb-[84px]">
                          <SearchBlock>
                            <div className="title flex items-center">
                              Offeror type&nbsp;
                              <Tooltip
                                width="280px"
                                text={
                                  <div className="tool-tip">
                                    <p className="mb-[5px]">
                                      <b className="underline underline-offset-2">
                                        Strategic Partner
                                      </b>{" "}
                                      - A Strategic Partner has a formal and collaborative
                                      relationship with Allinial Global.
                                    </p>
                                    <p>
                                      <b className="underline underline-offset-2">
                                        Preferred Vendor
                                      </b>{" "}
                                      - A Preferred Vendor is a vetted service or solution
                                      provider that offers a direct discount or benefit to
                                      Allinial Global members.
                                    </p>
                                  </div>
                                }
                              />
                            </div>
                            <AGSelect
                              isClearable
                              value={values.offerorTypeId || null}
                              onChange={(e: any) => {
                                setFieldValue("offerorTypeId", e);
                                setSearchParam({
                                  ...searchParam,
                                  page: 1,
                                  offerorTypeId: e?.value || null,
                                  isSearch: false,
                                });
                              }}
                              options={initDefaultValue.orgTypes
                                ?.map((e: any) => {
                                  return {
                                    value: e.orgTypeId,
                                    label: e.orgType1,
                                  };
                                })
                              }
                              placeholder="Select offeror type"
                            />
                          </SearchBlock>

                          <SearchBlock>
                            <div className="title">Offering type</div>
                            <AGSelect
                              isClearable
                              value={values.offeringTypeId || null}
                              onChange={(e: any) => {
                                setFieldValue("experiseServiceId", null);
                                setFieldValue("productCategoryId", null);
                                setFieldValue("specializedSecondmentId", null);
                                setFieldValue("offeringTypeId", e);
                                setSearchParam({
                                  ...searchParam,
                                  page: 1,
                                  experiseServiceId: undefined,
                                  productCategoryId: undefined,
                                  specializedSecondmentId: undefined,
                                  offeringTypeId: e?.value || null,
                                  isSearch: false,
                                });
                              }}
                              options={initDefaultValue.comOfferingTypes
                                ?.map((e: any) => ({
                                  value: e.offeringTypeId,
                                  label: e.offeringTypeName,
                                }))
                                .sort((a: any, b: any) => compare(a, b, "value"))}
                              placeholder="Select offering type"
                            />
                          </SearchBlock>

                          {searchParam?.offeringTypeId === 1 && (
                            <SearchBlock>
                              <div className="title">Specialized service</div>
                              <AGSelect
                                isClearable
                                isDisabled={searchParam?.offeringTypeId !== 1}
                                value={values.experiseServiceId}
                                onChange={(e: any) => {
                                  setFieldValue("experiseServiceId", e);
                                  setSearchParam({
                                    ...searchParam,
                                    page: 1,
                                    experiseServiceId: e?.value,
                                    isSearch: false,
                                  });
                                }}
                                options={[
                                  ...(initDefaultValue.specializedServices
                                    ?.map((e: any) => ({
                                      value: e.mainServiceId,
                                      label: e.mainServiceName,
                                    }))
                                    .sort((a: any, b: any) => compare(a, b, "label")) || []),
                                  { value: -1, label: INQUIRY_MORE_OPTION.OTHER }
                                ]}
                                placeholder="Select service"
                              />
                            </SearchBlock>
                          )}

                          {searchParam?.offeringTypeId === 2 && (
                            <SearchBlock>
                              <div className="title">Specialized product</div>
                              <AGSelect
                                isClearable
                                isDisabled={searchParam?.offeringTypeId !== 2}
                                value={values.productCategoryId}
                                onChange={(e: any) => {
                                  setFieldValue("productCategoryId", e);
                                  setSearchParam({
                                    ...searchParam,
                                    page: 1,
                                    productCategoryId: e?.value,
                                  });
                                }}
                                options={[
                                  ...(initDefaultValue.specializedProducts
                                    ?.map((e: any) => ({
                                      value: e.mainServiceId,
                                      label: e.mainServiceName,
                                    }))
                                    .sort((a: any, b: any) => compare(a, b, "label")) || []),
                                  { value: -1, label: INQUIRY_MORE_OPTION.OTHER }
                                ]}
                                placeholder="Select product"
                              />
                            </SearchBlock>
                          )}

                          {searchParam?.offeringTypeId === 3 && (
                            <SearchBlock>
                              <div className="title">Specialized service</div>
                              <AGSelect
                                isClearable
                                isDisabled={searchParam?.offeringTypeId !== 3}
                                value={values.specializedSecondmentId}
                                onChange={(e: any) => {
                                  setFieldValue("specializedSecondmentId", e);
                                  setSearchParam({
                                    ...searchParam,
                                    page: 1,
                                    specializedSecondmentId: e?.value,
                                    isSearch: false,
                                  });
                                }}
                                options={[
                                  ...(initDefaultValue.specializedSecondments
                                    ?.map((e: any) => ({
                                      value: e.mainServiceId,
                                      label: e.mainServiceName,
                                    }))
                                    .sort((a: any, b: any) => compare(a, b, "label")) || []),
                                  { value: -1, label: INQUIRY_MORE_OPTION.OTHER }
                                ]}
                                placeholder="Select service"
                              />
                            </SearchBlock>
                          )}

                          <SearchBlock>
                            <div className="title">Inquiry initiator</div>
                            <AGInput
                              value={values.InquiryInitator || ""}
                              placeholder="Enter inquiry initiator"
                              onChange={(e) => {
                                setFieldValue("InquiryInitator", e.target.value);
                                setSearchParam({
                                  ...searchParam,
                                  page: 1,
                                  InquiryInitator: e.target.value || "",
                                  isSearch: false,
                                });
                              }}
                            />
                          </SearchBlock>
                          <SearchBlock>
                            <div className="title">Inquiry status</div>
                            <AGSelect
                              isClearable
                              value={values.InquiryStatusId || null}
                              onChange={(e: any) => {
                                setFieldValue("InquiryStatusId", e);
                                setSearchParam({
                                  ...searchParam,
                                  page: 1,
                                  InquiryStatusId: e?.value || null,
                                  isSearch: false,
                                });
                              }}
                              options={initDefaultValue.inquiryStatuses
                                ?.map((e: any) => {
                                  return {
                                    value: e.inquiryStatusId,
                                    label: e.status,
                                  };
                                })
                                .sort((a: any, b: any) => compare(a, b, "value"))}
                              placeholder="Select inquiry status"
                            />
                          </SearchBlock>
                          <SearchBlock>
                            <div className="title">Date range</div>
                            <AddIconDatePicker>
                                <MobileWrappedDatePicker ref = {mobileCalendarStartDateWrapperRef}>
                                <StyledDatePicker
                                  isClearable
                                  selectsRange
                                  dateFormat={"MM/dd/yyyy"}
                                      minDate = {dateRangeMinDate}
                                  maxDate={new Date()}
                                  onChange={(dates: any) => {
                                    const [start, end] = dates;

                                        if (isSelectingStartDate){
                                          if (start){
                                        setFieldValue("startDate", start);
                                        setIsSelectingStartDate(false);
                                        setDateRageMinDate(start);
                                      }
                                          if (start && end){
                                        setFieldValue("startDate", end);
                                        setIsSelectingStartDate(false);
                                        setDateRageMinDate(end);
                                      }
                                          if (values.endDate && start>values.endDate){
                                        setFieldValue("startDate", start);
                                        setFieldValue("endDate", undefined);
                                        setIsSelectingStartDate(false);
                                        setDateRageMinDate(start);
                                      }
                                        }else{
                                          if (start && !end){
                                        setFieldValue("endDate", start);
                                        setIsCalendarDateRangeOpen(false);
                                        setSearchParam({
                                          ...searchParam,
                                          page: 1,
                                          startDate: values.startDate,
                                          endDate: start,
                                        });
                                          }else{
                                        setFieldValue("endDate", end);
                                        setIsSelectingStartDate(true);
                                        setIsCalendarDateRangeOpen(false);

                                        setSearchParam({
                                          ...searchParam,
                                          page: 1,
                                          startDate: values.startDate,
                                          endDate: end
                                        });
                                      }
                                    }

                                        if (!start && !end){
                                      setFieldValue("startDate", undefined);
                                      setFieldValue("endDate", undefined);
                                      setIsSelectingStartDate(true);
                                      setSearchParam({
                                        ...searchParam,
                                        page: 1,
                                        startDate: undefined,
                                        endDate: undefined
                                      });
                                    }

                                  }}
                                  placeholderText="mm/dd/yyyy - mm/dd/yyyy"
                                  startDate={values.startDate}
                                  endDate={values.endDate}
                                  openToDate={values.endDate}
                                      onInputClick={()=>{
                                    setIsCalendarDateRangeOpen(true);
                                    const clickPosition = mobileCalendarStartDateWrapperRef?.current?.querySelector("input")?.selectionStart ?? 0;
                                        if (clickPosition <= 11){
                                      setIsSelectingStartDate(true);
                                      setDateRageMinDate(undefined);
                                        }else{
                                      setIsSelectingStartDate(false);
                                      setDateRageMinDate(values.startDate);
                                    }
                                  }}
                                      onClickOutside={(event: any)=>{
                                    if (
                                      mobileCalendarStartDateWrapperRef.current &&
                                      !mobileCalendarStartDateWrapperRef.current.contains(
                                        event.target as Node,
                                      )
                                        ) 
                                        {
                                      setIsCalendarDateRangeOpen(false);
                                      if (values.startDate && !values.endDate) {
                                        setFieldValue("startDate", undefined);
                                        setFieldValue("endDate", undefined);
                                        setSearchParam({
                                          ...searchParam,
                                          page: 1,
                                          startDate: undefined,
                                          endDate: undefined,
                                        });
                                      }
                                    }
                                    if (values.startDate && values.endDate) {
                                      setSearchParam({
                                        ...searchParam,
                                        page: 1,
                                        startDate: values.startDate,
                                        endDate: values.endDate,
                                      });
                                    }
                                    setIsSelectingStartDate(true);
                                  }}
                                      open = {isCalendarDateRangeOpen}
                                  onKeyDown={handleNumericDateInput}
                                />
                              </MobileWrappedDatePicker>
                            </AddIconDatePicker>
                          </SearchBlock>

                          {openMobileMenu ? (
                            <CustomButtonSearch>
                              <SearchBlock>
                                <div className="center-button flex !justify-between">
                                  <AGButtonV2
                                    onClick={() => {
                                      setSearchParam(resetClearForm);

                                      resetForm();
                                      setSearchParamResetData({});
                                      setOpenMobileMenu(false);
                                    }}
                                    hasHover={false}
                                    bgColor="#637381"
                                    color="#637381"
                                  >
                                    <span className="text-white">Clear filters</span>
                                  </AGButtonV2>
                                  <AGButtonV2
                                    onClick={() => {
                                      setFieldValue("isUserSearch", true);
                                      setSearchParam({
                                        ...searchParam,
                                        page: 1,
                                        isSearch: true,
                                      });
                                      setSearchParamResetData(values);
                                      setOpenMobileMenu(false);
                                    }}
                                    hasHover={false}
                                    bgColor="#0971A2"
                                    color="#0971A2"
                                  >
                                    <span className="text-white">Apply filters</span>
                                  </AGButtonV2>
                                </div>
                              </SearchBlock>
                            </CustomButtonSearch>
                          ) : null}
                        </form>
                      </MobileSearch>
                    );
                  }}
                </Formik>
              </>
            ) : (
              <>
                <Card style={{padding: "5px 0"}}>
                  <Formik
                    initialValues={searchParam}
                    onSubmit={(values, setf) => {}}
                  >
                    {({values, setFieldValue}) => {
                      return (
                        <div>
                          <SearchBlock>
                            <div className="title flex items-center">
                              Offeror type&nbsp;
                              <Tooltip
                                width="280px"
                                text={
                                  <div className="tool-tip">
                                    <p className="mb-[5px]">
                                      <b className="underline underline-offset-2">
                                        Strategic Partner
                                      </b>{" "}
                                      - A Strategic Partner has a formal and collaborative
                                      relationship with Allinial Global.
                                    </p>
                                    <p>
                                      <b className="underline underline-offset-2">
                                        Preferred Vendor
                                      </b>{" "}
                                      - A Preferred Vendor is a vetted service or solution
                                      provider that offers a direct discount or benefit to
                                      Allinial Global members.
                                    </p>
                                  </div>
                                }
                              />
                            </div>
                            <AGSelect
                              isClearable
                              value={values.offerorTypeId}
                              onChange={(e: any) => {
                                setFieldValue("offerorTypeId", e);
                                setSearchParam({
                                  ...searchParam,
                                  page: 1,
                                  offerorTypeId: e?.value,
                                  isSearch: true,
                                });
                              }}
                              options={initDefaultValue.orgTypes
                                ?.map((e: any) => {
                                  return {
                                    value: e.orgTypeId,
                                    label: e.orgType1,
                                  };
                                })
                              }
                              placeholder="Select offeror type"
                            />
                          </SearchBlock>
                          <SearchBlock>
                            <div className="title">Offering type</div>
                            <AGSelect
                              isClearable
                              value={values.offeringTypeId}
                              onChange={(e: any) => {
                                setFieldValue("experiseServiceId", null);
                                setFieldValue("productCategoryId", null);
                                setFieldValue("specializedSecondmentId", null);
                                setFieldValue("offeringTypeId", e);
                                setSearchParam({
                                  ...searchParam,
                                  page: 1,
                                  experiseServiceId: undefined,
                                  productCategoryId: undefined,
                                  specializedSecondmentId: undefined,
                                  offeringTypeId: e?.value,
                                  isSearch: true,
                                });
                              }}
                              options={initDefaultValue.comOfferingTypes
                                ?.map((e: any) => {
                                  return {
                                    value: e.offeringTypeId,
                                    label: e.offeringTypeName,
                                  };
                                })
                                .sort((a: any, b: any) => compare(a, b, "value"))}
                              placeholder="Select offering type"
                            />
                          </SearchBlock>

                          {searchParam?.offeringTypeId === 1 && (
                            <SearchBlock>
                              <div className="title">Specialized service</div>
                              <AGSelect
                                isClearable
                                isDisabled={searchParam?.offeringTypeId !== 1}
                                value={values.experiseServiceId}
                                onChange={(e: any) => {
                                  setFieldValue("experiseServiceId", e);
                                  setSearchParam({
                                    ...searchParam,
                                    page: 1,
                                    experiseServiceId: e?.value,
                                    isSearch: true,
                                  });
                                }}
                                options={[
                                  ...(initDefaultValue.specializedServices
                                    ?.map((e: any) => ({
                                      value: e.mainServiceId,
                                      label: e.mainServiceName,
                                    }))
                                    .sort((a: any, b: any) => compare(a, b, "label")) || []),
                                  { value: -1, label: INQUIRY_MORE_OPTION.OTHER }
                                ]}
                                placeholder="Select service"
                              />
                            </SearchBlock>
                          )}

                          {searchParam?.offeringTypeId === 2 && (
                            <SearchBlock>
                              <div className="title">Specialized product</div>
                              <AGSelect
                                isClearable
                                isDisabled={searchParam?.offeringTypeId !== 2}
                                value={values.productCategoryId}
                                onChange={(e: any) => {
                                  setFieldValue("productCategoryId", e);
                                  setSearchParam({
                                    ...searchParam,
                                    page: 1,
                                    productCategoryId: e?.value,
                                    isSearch: true,
                                  });
                                }}
                                options={[
                                  ...(initDefaultValue.specializedProducts
                                    ?.map((e: any) => ({
                                      value: e.mainServiceId,
                                      label: e.mainServiceName,
                                    }))
                                    .sort((a: any, b: any) => compare(a, b, "label")) || []),
                                  { value: -1, label: INQUIRY_MORE_OPTION.OTHER }
                                ]}
                                placeholder="Select product"
                              />
                            </SearchBlock>
                          )}

                          {searchParam?.offeringTypeId === 3 && (
                            <SearchBlock>
                              <div className="title">Specialized service</div>
                              <AGSelect
                                isClearable
                                isDisabled={searchParam?.offeringTypeId !== 3}
                                value={values.specializedSecondmentId}
                                onChange={(e: any) => {
                                  setFieldValue("specializedSecondmentId", e);
                                  setSearchParam({
                                    ...searchParam,
                                    page: 1,
                                    specializedSecondmentId: e?.value,
                                    isSearch: true,
                                  });
                                }}
                                options={[
                                  ...(initDefaultValue.specializedSecondments
                                    ?.map((e: any) => ({
                                      value: e.mainServiceId,
                                      label: e.mainServiceName,
                                    }))
                                    .sort((a: any, b: any) => compare(a, b, "label")) || []),
                                  { value: -1, label: INQUIRY_MORE_OPTION.OTHER }
                                ]}
                                placeholder="Select service"
                              />
                            </SearchBlock>
                          )}

                          <SearchBlock>
                            <div className="title">Inquiry initiator</div>
                            <AGInput
                              value={values.InquiryInitator}
                              placeholder="Enter inquiry initiator"
                              onChange={(e) =>
                                setSearchParam({
                                  ...searchParam,
                                  page: 1,
                                  InquiryInitator: e?.target.value,
                                  isSearch: true,
                                })
                              }
                            />
                          </SearchBlock>
                          <SearchBlock>
                            <div className="title">Inquiry status</div>
                            <AGSelect
                              isClearable
                              value={values.InquiryStatusId}
                              onChange={(e: any) => {
                                setFieldValue("InquiryStatusId", e);
                                setSearchParam({
                                  ...searchParam,
                                  page: 1,
                                  InquiryStatusId: e?.value,
                                  isSearch: true,
                                });
                              }}
                              options={initDefaultValue.inquiryStatuses
                                ?.map((e: any) => {
                                  return {
                                    value: e.inquiryStatusId,
                                    label: e.status,
                                  };
                                })
                                .sort((a: any, b: any) => compare(a, b, "value"))}
                              placeholder="Select inquiry status"
                            />
                          </SearchBlock>
                          <SearchBlock>
                            <div className="title">Date range</div>
                            <AddIconDatePicker>
                              <WrappedDatePicker ref={calendarStartDateWrapperRef}>
                                <StyledDatePicker
                                  isClearable
                                  selectsRange
                                  dateFormat={"MM/dd/yyyy"}
                                  minDate={dateRangeMinDate}
                                  maxDate={new Date()}
                                  onChange={(dates: any) => {
                                    const [start, end] = dates;

                                    if (isSelectingStartDate) {
                                      if (start) {
                                        setFieldValue("startDate", start);
                                        setIsSelectingStartDate(false);
                                        setDateRageMinDate(start);
                                      }
                                      if (start && end) {
                                        setFieldValue("startDate", end);
                                        setIsSelectingStartDate(false);
                                        setDateRageMinDate(end);
                                      }
                                      if (values.endDate && start > values.endDate) {
                                        setFieldValue("startDate", start);
                                        setFieldValue("endDate", undefined);
                                        setIsSelectingStartDate(false);
                                        setDateRageMinDate(start);
                                      }
                                    } else {
                                      if (start && !end) {
                                        setFieldValue("endDate", start);
                                        setIsCalendarDateRangeOpen(false);
                                        setSearchParam({
                                          ...searchParam,
                                          page: 1,
                                          startDate: values.startDate,
                                          endDate: start,
                                          isSearch: true,
                                        });
                                      } else {
                                        setFieldValue("endDate", end);
                                        setIsSelectingStartDate(true);
                                        setIsCalendarDateRangeOpen(false);

                                        setSearchParam({
                                          ...searchParam,
                                          page: 1,
                                          startDate: values.startDate,
                                          endDate: end,
                                          isSearch: true,
                                        });
                                      }
                                    }

                                    if (!start && !end) {
                                      setFieldValue("startDate", undefined);
                                      setFieldValue("endDate", undefined);
                                      setIsSelectingStartDate(true);
                                      setDateRageMinDate(undefined);
                                      setIsCalendarDateRangeOpen(false);
                                      setSearchParam({
                                        ...searchParam,
                                        page: 1,
                                        startDate: undefined,
                                        endDate: undefined,
                                        isSearch: true,
                                      });
                                    }
                                  }}
                                  placeholderText="mm/dd/yyyy - mm/dd/yyyy"
                                  startDate={values.startDate}
                                  endDate={values.endDate}
                                  openToDate={values.endDate}
                                  onInputClick={() => {
                                    setIsCalendarDateRangeOpen(true);
                                    const clickPosition =
                                      calendarStartDateWrapperRef?.current?.querySelector("input")
                                        ?.selectionStart ?? 0;
                                    if (clickPosition <= 11) {
                                      setIsSelectingStartDate(true);
                                      setDateRageMinDate(undefined);
                                    } else {
                                      setIsSelectingStartDate(false);
                                      setDateRageMinDate(values.startDate);
                                    }
                                  }}
                                  onClickOutside={(event: any) => {
                                    if (
                                      calendarStartDateWrapperRef.current &&
                                      !calendarStartDateWrapperRef.current.contains(
                                        event.target as Node,
                                      )
                                    ) {
                                      setIsCalendarDateRangeOpen(false);
                                      if (values.startDate && !values.endDate) {
                                        setFieldValue("startDate", undefined);
                                        setFieldValue("endDate", undefined);
                                        setSearchParam({
                                          ...searchParam,
                                          page: 1,
                                          startDate: undefined,
                                          endDate: undefined,
                                          isSearch: true,
                                        });
                                      }
                                    }
                                    if (values.startDate && values.endDate) {
                                      setSearchParam({
                                        ...searchParam,
                                        page: 1,
                                        startDate: values.startDate,
                                        endDate: values.endDate,
                                        isSearch: true,
                                      });
                                    }
                                    setIsSelectingStartDate(true);
                                  }}
                                  open={isCalendarDateRangeOpen}
                                  onKeyDown={handleNumericDateInput}
                                />
                              </WrappedDatePicker>
                            </AddIconDatePicker>
                          </SearchBlock>
                        </div>
                      );
                    }}
                  </Formik>
                </Card>
              </>
            )}
          </div>
          <div className={`${isMobileScreen ? "" : "flex-1 mt-[20px]"} 769:w-48 lg:w-[17rem]`}>
            <div className={`${isMobileScreen ? "fixed inset-x-0 top-[90px] bg-white shadow-lg  before:block before:absolute before:top-[-50px] before:z-[-2] before:bg-[#e4e4e4] before:w-full before:h-[70px]" : "top-[70px]"} sticky bg-[#d3d3d3] custom-fixed z-20`}>
              <div
                style={{
                  width: isMobileScreen ? screenWidth : "",
                }}
                className={`${isMobileScreen ? "top-[90px]"
                  : "top-[70px]"} p-[1rem] h-[70px] sticky border-t-2 border-b-2 border-solid border-[#EAEAEA] bg-white rounded-lg`}
              >
                <div className="flex items-center overflow-x-auto flex-nowrap no-scrollbar-disable">
                  <div className="sticky left-0 z-10 bg-white mr-[10px] h-[39px] items-center flex justify-center">
                    {isMobileScreen ? (
                      <>
                        <AGButtonV2
                          onClick={() => {
                            setIsClickFilterOnMobile(true);
                            setOpenMobileMenu(true);
                          }}
                          color="#333333"
                          hasHover={false}
                          icon={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={14}
                              height={14}
                              viewBox="0 0 14 14"
                              fill="none"
                              className="  fill-[#333333]"
                            >
                              <path
                                d="M4.94699 0.117188C4.02615 0.117188 3.2438 0.738573 2.9902 1.59017H0.894911C0.572984 1.59017 0.342773 1.84377 0.342773 2.1657C0.342773 2.48762 0.596374 2.74122 0.918301 2.74122H3.01359C3.2438 3.59282 4.04954 4.21421 4.97038 4.21421C5.91461 4.21421 6.69696 3.59282 6.95056 2.74122H15.4449C15.7668 2.74122 16.0204 2.48762 16.0204 2.1657C16.0204 1.84377 15.7668 1.59017 15.4449 1.59017H6.95056C6.6736 0.738573 5.8912 0.117188 4.94699 0.117188ZM4.97037 1.26824C5.45418 1.26824 5.86783 1.65942 5.86783 2.1657C5.86783 2.67198 5.45326 3.06315 4.97037 3.06315C4.48656 3.06315 4.07292 2.67198 4.07292 2.1657C4.07202 1.65942 4.48658 1.26824 4.97037 1.26824Z"
                                fill="black"
                              />
                              <path
                                d="M11.8768 4.72168C10.956 4.72168 10.1736 5.34306 9.92001 6.19466H0.918301C0.572984 6.19466 0.342773 6.44826 0.342773 6.77019C0.342773 7.09212 0.596374 7.34572 0.918301 7.34572H9.92001C10.1502 8.19731 10.956 8.8187 11.8768 8.8187C12.821 8.8187 13.6034 8.19731 13.857 7.34572H15.4451C15.767 7.34572 16.0206 7.09212 16.0206 6.77019C16.0206 6.44826 15.767 6.19466 15.4451 6.19466H13.857C13.6034 5.34306 12.8201 4.72168 11.8768 4.72168ZM11.8993 5.87273C12.3831 5.87273 12.7967 6.26391 12.7967 6.77019C12.7967 7.27647 12.3822 7.66764 11.8993 7.66764C11.4155 7.66764 11.0018 7.27647 11.0018 6.77019C11.0018 6.26391 11.393 5.87273 11.8993 5.87273Z"
                                fill="black"
                              />
                              <path
                                d="M7.70952 9.78613C6.78868 9.78613 6.00633 10.4075 5.75273 11.2591H0.918301C0.572984 11.2591 0.342773 11.5127 0.342773 11.8346C0.342773 12.1566 0.596374 12.4102 0.918301 12.4102H5.77621C6.00642 13.2618 6.81216 13.8832 7.73301 13.8832C8.67724 13.8832 9.45959 13.2618 9.71319 12.4102H15.445C15.7669 12.4102 16.0205 12.1566 16.0205 11.8346C16.0205 11.5127 15.7669 11.2591 15.445 11.2591H9.68971C9.43611 10.4075 8.65376 9.78613 7.70952 9.78613ZM7.7329 10.9372C8.21671 10.9372 8.63036 11.3284 8.63036 11.8346C8.63036 12.3409 8.21579 12.7321 7.7329 12.7321C7.24909 12.7321 6.83545 12.3409 6.83545 11.8346C6.85793 11.3284 7.24911 10.9372 7.7329 10.9372Z"
                                fill="black"
                              />
                            </svg>
                          }
                        ></AGButtonV2>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  {TAB_DISPLAY.map((t) => {
                    return (
                      <AGButtonV2
                        {...(searchParam?.tabName === t.key
                          ? {
                            className:
                              "disabled:opacity-40 group disabled:cursor-not-allowed flex justify-center items-center px-[22px] py-[8px] mr-[10px] last:mr-0 rounded-[20px] text-[#ffffff] bg-[#0971A2] cursor-pointer border-[1px] border-solid group gap-[10px]",
                          }
                          : {})}
                        onClick={() => {
                          setInboxMessageSearchData([]);
                          setInboxMessageData({});
                          if (!isLoadingInbox) {
                            setSearchURLParam((params) => {
                              params.set("page", "1");
                              return params;
                            });
                            setSearchParam({
                              ...searchParam,
                              page: 1,
                              tabName: t.key,
                              isSearch: true,
                            });
                          }
                        }}
                      >
                        {t.name}
                      </AGButtonV2>
                    );
                  })}
                  <div className="ml-auto">
                    <a
                      role="button"
                      onClick={() => {
                        setIsClickAddInquiry(true);
                        setShowAddingInquiryForm(true);
                      }}
                      className="mr-[20px] focus:ring focus:ring-blue-300 link-redirect whitespace-nowrap font-bold"
                    >
                      Add Inquiry
                    </a>
                    <a
                      role="button"
                      onClick={() => {
                        setIsClickExportExcel(true);
                        handleExportToExcel();
                      }}
                      className="ml-auto focus:ring focus:ring-blue-300 link-redirect whitespace-nowrap font-bold"
                    >
                      Export to Excel
                    </a>
                  </div>
                </div>
              </div>
              {!isMobileScreen && (
                <div className="sticky flex justify-start w-full bg-white py-[20px] text-[0.9375rem] font-bold text-start text-[#333333] top-[170px] z-50 mt-[10px]">
                  <div className="flex-[26%] lg:flex-[29%] flex justify-start pl-[20px] pr-[10px]"></div>
                  <div className="flex-[26%] lg:flex-[29%] flex justify-start pr-[10px]">
                    Subject
                  </div>
                  <div className="flex-[15%] flex justify-start pr-[10px]">Offering Type</div>
                  <div className="flex-[13%] justify-start pr-[10px]">Status</div>
                  <div className="flex-[20%] lg:flex-[14%] flex justify-start pr-[10px]"></div>
                </div>
              )}
            </div>

            <Card>
              {searchParam.tabName === "tab_received_inbox" ? (
                <MailTable
                  data={inboxMessageSearchData}
                  onOpenMessageDetail={(e, cell) => {
                    if (cell?.target?.innerText === "Delete") {
                      updateInfoAction("Delete", e);
                    } else if (cell?.target?.innerText === "Edit") {
                      updateInfoAction("Edit", e);
                    } else {
                      setInboxDetail(e);
                      setMessageModel({
                        ...messageModel,
                        action: "DETAIL",
                        title: "Inquiry Details",
                        isShowModal: true,
                        readonly: true,
                      });

                      if (searchParam.tabName === TAB_NAME[0].key) {
                        if (!e.isReaded) {
                          updateReadedInbox({
                            inboxMessageId: e.inboxMessageId,
                          });
                          getCountUnreadInbox();
                        }
                      }
                    }
                  }}
                  isClickOnRow={true}
                  dataInbox={inboxMessageData}
                  onLoadMore={() => {
                    setSearchParam({
                      ...searchParam,
                      page: (searchParam.page ?? 0) + 1,
                      isSearch: true,
                    });
                  }}
                  onClickEdit={(inboxMessageId: any)=>{
                    setShowEditingInquiryForm(true);
                    updateReadedInbox({
                      inboxMessageId: inboxMessageId,
                    });
                    getCountUnreadInbox();
                  }}
                  isLoading={isLoadingInbox}
                  getInquiryDetails={getInquiryDetails}
                  setDeletedInboxMessageId={setDeletedInboxMessageId}
                  updateInfoAction={updateInfoAction}
                  isClickAddInquiry={isClickAddInquiry}
                  isClickExportExcel={isClickExportExcel}
                  isClickFilterOnMobile={isClickFilterOnMobile}
                  onCloseTrailItem={() => {
                    setIsClickAddInquiry(false);
                    setIsClickExportExcel(false);
                    setIsClickFilterOnMobile(false);
                  }}
                />
              ) : (
                <SentMailTable
                  data={inboxMessageSearchData}
                  onOpenMessageDetail={(e, cell) => {
                    if (cell?.target?.innerText === "Delete") {
                      updateInfoAction("Delete", e);
                    } else if (cell?.target?.innerText === "Edit") {
                      updateInfoAction("Edit", e);
                    } else {
                      setInboxDetail(e);
                      setMessageModel({
                        ...messageModel,
                        action: "DETAIL",
                        title: "Inquiry Details",
                        isShowModal: true,
                        readonly: true,
                      });
                    }
                  }}
                  isClickOnRow={true}
                  onLoadMore={() => {
                    setSearchParam({
                      ...searchParam,
                      page: (searchParam.page ?? 0) + 1,
                      isSearch: true,
                    });
                  }}
                  dataInbox={inboxMessageData}
                  isLoading={isLoadingInbox}
                  getInquiryDetails={getInquiryDetails}
                  setDeletedInboxMessageId={setDeletedInboxMessageId}
                  onClickEdit={(inboxMessageId: any)=>{
                    updateReadedInbox({
                      inboxMessageId: inboxMessageId,
                    });
                    getCountUnreadInbox();
                    setShowEditingInquiryForm(true);
                  }}
                  updateInfoAction={updateInfoAction}
                  isClickAddInquiry={isClickAddInquiry}
                  isClickExportExcel={isClickExportExcel}
                  isClickFilterOnMobile={isClickFilterOnMobile}
                  onCloseTrailItem={() => {
                    setIsClickAddInquiry(false);
                    setIsClickExportExcel(false);
                    setIsClickFilterOnMobile(false);
                  }}

                />
              )}
            </Card>
          </div>
        </div>
      </Container>

      <MessageModal
        title={messageModel.title}
        visible={messageModel.isShowModal}
        metaData={initDefaultValue}
        readonly={messageModel.readonly}
        inboxDetail={inboxDetail}
        action={messageModel.action}
        toggleModal={() => {
          setMessageModel({
            ...messageModel,
            isShowModal: !messageModel.isShowModal,
          });
        }}
      />

      <AGModalComfirmModal
        title="Delete inquiry"
        visible={showConfirmDelete}
        setHeight={190}
        footer={
          <>
            {" "}
            <AGButton
              type="Primary"
              onClick={() => {
                deleteInquiry(deletedInboxMessageId);
              }}
            >
              Delete
            </AGButton>
            <AGButton
              type="Secondary"
              onClick={() => {
                setShowConfirmDelete(false);
              }}
            >
              Cancel
            </AGButton>
          </>
        }
        toggleModal={() => {
          setShowConfirmDelete(false);
        }}
      >
        <div style={{padding: 20}}>Are you sure you want to delete this inquiry?</div>
      </AGModalComfirmModal>
    </div>
  );
};

export default React.memo(InboxMessagePage);

const CloseButton = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={23}
      height={23}
      viewBox="0 0 23 23"
      fill="none"
      {...props}
    >
      <path
        d="M22.1471 19.1948C22.962 20.0106 22.962 21.3313 22.1471 22.1471C21.3313 22.962 20.0106 22.962 19.1948 22.1471L11.8367 14.7889C11.6507 14.602 11.3488 14.602 11.1628 14.7889L3.80466 22.1471C2.98887 22.962 1.66817 22.962 0.852378 22.1471C0.0374884 21.3313 0.0374884 20.0106 0.852378 19.1948L8.21054 11.8375C8.39741 11.6507 8.39741 11.3488 8.21054 11.1628L0.852378 3.80466C0.0374884 2.98887 0.0374884 1.66817 0.852378 0.852378C1.66817 0.0374884 2.98887 0.0374884 3.80466 0.852378L11.1628 8.21146C11.3488 8.39743 11.6507 8.39743 11.8367 8.21146L19.1948 0.852378C20.0106 0.0374884 21.3313 0.0374884 22.1471 0.852378C22.962 1.66817 22.962 2.98887 22.1471 3.80466L14.7889 11.1628C14.6021 11.3488 14.6021 11.6507 14.7889 11.8375L22.1471 19.1948Z"
        fill="#58585B"
      />
    </svg>
  );
};
